//@ts-check
import React from 'react';
import { FolderWorkflowProvider, withFolderWorkflowConsumer } from './FolderWorkflowContext';
import FolderWorkflowManage from './FolderWorkflowManage';

const FolderWorkflowManageWrapper = (props) => {
    return (
        <FolderWorkflowProvider>
            <FolderWorkflowManageWithConsumer {...props}></FolderWorkflowManageWithConsumer>
        </FolderWorkflowProvider>
    );
};

const FolderWorkflowManageWithConsumer = withFolderWorkflowConsumer(FolderWorkflowManage);

export { FolderWorkflowManageWrapper };
